/* eslint-disable */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from './routes';

function Navigate(props) {
    const navigate = useNavigate();

    useEffect(() => {
        if (props.to) {
            navigate(props.to);
        } else {
            navigate(AppRoutes.dashboard);
        }
    });

    return (
        <div></div>
    );
}

export default Navigate;